import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import IndustryPage from "@/pages/IndustryPage";

export const Route = createFileRoute("/es/industrias/in-vitro-diagnostics/")({
  head: () => buildRouteHead("/es/industrias/in-vitro-diagnostics"),
  component: IndustryPage,
});

